import { SupplyTransferStatusName, SupplyShipmentCarrier, SupplyShipmentStatusName, ShipmentType } from '@caresend/types';
import { initTimeZoneDate } from './date.js';
import { generateID } from './id.js';
import { initLocationObject } from './location.js';

const initSupplyTransfer = draftWaypoint => {
  const supplyTransferStatus = {
    status: SupplyTransferStatusName.CREATED,
    timestamp: Date.now()
  };
  return {
    creationTimestamp: Date.now(),
    draftWaypointID: draftWaypoint.id,
    procedures: draftWaypoint.procedures,
    id: generateID(),
    status: supplyTransferStatus
  };
};
const initDraftSupplyShipment = shipment => Object.assign({
  cost: undefined,
  creationTimestamp: Date.now(),
  deliveryMethod: SupplyShipmentCarrier.UPS,
  id: generateID(),
  placeID: undefined,
  shipBy: initTimeZoneDate(),
  shippingRecipient: undefined,
  shippingAddress: initLocationObject(),
  shippingLabelBarcode: undefined,
  shippingLabelURL: undefined,
  shipmentBoxSupplyID: undefined,
  shopifyInfo: undefined,
  status: {
    status: SupplyShipmentStatusName.PENDING_LABEL,
    timestamp: Date.now()
  },
  transferID: undefined,
  trackingURL: undefined,
  type: ShipmentType.SUPPLY
}, shipment);
const initShipment = () => ({
  creationTimestamp: Date.now(),
  deliveryMethod: SupplyShipmentCarrier.FED_EX,
  id: generateID(),
  shippingRecipient: '',
  shippingAddress: initLocationObject(),
  shippingLabelBarcode: '',
  status: {
    status: SupplyShipmentStatusName.PENDING_LABEL,
    timestamp: Date.now()
  },
  shopifyInfo: {
    shopifyOrderID: 0,
    orderStatusURL: ''
  },
  trackingURL: '',
  type: ShipmentType.SAMPLE
});

export { initDraftSupplyShipment, initShipment, initSupplyTransfer };
